<template>
  <h1
    class="text-[24px] md:text-[30px] font-normal md:font-thin text-white mb-10 px-12 md:px-0"
  >
    People
  </h1>
  <InvitationsView />
</template>

<script setup>
import InvitationsView from '@features/workspaces/InvitationsView.vue';
</script>
